// id: for us_day_of_week table
// code: for us_day_of_week table
// day: for Javascript Date object
// filterKey: for FilterDTO in supported API calls
// label: for client display only

import { DayOfWeekOption } from 'us-web-services';

export const daysOfWeek: DayOfWeekOption[] = [
  {
    id: 1,
    code: 'SUN',
    day: 0,
    filterKey: 'sundayAvailability',
    label: 'Sunday',
  },
  {
    id: 2,
    code: 'MON',
    day: 1,
    filterKey: 'mondayAvailability',
    label: 'Monday',
  },
  {
    id: 3,
    code: 'TUE',
    day: 2,
    filterKey: 'tuesdayAvailability',
    label: 'Tuesday',
  },
  {
    id: 4,
    code: 'WED',
    day: 3,
    filterKey: 'wednesdayAvailability',
    label: 'Wednesday',
  },
  {
    id: 5,
    code: 'THU',
    day: 4,
    filterKey: 'thursdayAvailability',
    label: 'Thursday',
  },
  {
    id: 6,
    code: 'FRI',
    day: 5,
    filterKey: 'fridayAvailability',
    label: 'Friday',
  },
  {
    id: 7,
    code: 'SAT',
    day: 6,
    filterKey: 'saturdayAvailability',
    label: 'Saturday',
  }
];
